import { render, staticRenderFns } from "./VIPTicketLink.vue?vue&type=template&id=03b6cad1"
import script from "./VIPTicketLink.vue?vue&type=script&lang=js"
export * from "./VIPTicketLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports